import * as React from 'react'

function IconConcaveCylinderTime({
  isFill,
  props,
}: {
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={143}
      viewBox="0 0 104 143"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g
            filter="url(#filter4_concave)"
            strokeMiterlimit={10}
            strokeLinecap="round"
          >
            <path
              d="M98.893 129.184c-16.58 16.309-77.206 16.309-93.786 0-10.419-10.248 2.271-34.11 2.271-57.979 0-23.867-12.69-47.726-2.27-57.974 16.579-16.308 77.205-16.308 93.785 0 10.419 10.248-2.271 34.111-2.271 57.98 0 23.867 12.69 47.721 2.27 57.973z"
              fill="#fff"
              stroke="#A2A2A2"
              strokeWidth={2}
            />
            <path
              d="M52.002 132.143c-18.328 0-35.246-4.077-41.138-9.917-2.654-2.627-.55-12.994 1.305-22.141 1.772-8.734 3.78-18.632 3.78-28.877 0-10.245-2.008-20.143-3.78-28.877-1.854-9.148-3.959-19.515-1.305-22.142 5.892-5.84 22.81-9.916 41.138-9.916s35.246 4.076 41.134 9.916c2.654 2.632.55 12.994-1.305 22.142-1.772 8.734-3.78 18.632-3.78 28.877 0 10.245 2.008 20.143 3.78 28.877 1.854 9.147 3.959 19.514 1.305 22.141-5.888 5.84-22.806 9.917-41.134 9.917z"
              fill="#A2A2A2"
              stroke="#fff"
            />
            <path
              d="M52.041 93.147c12.094 0 21.898-9.804 21.898-21.898s-9.804-21.898-21.898-21.898-21.898 9.804-21.898 21.898 9.804 21.898 21.898 21.898z"
              stroke="#fff"
              strokeWidth={6}
            />
            <path
              d="M52.041 59.427v8.567c0 2.084.826 4.087 2.303 5.564l5.017 5.016"
              stroke="#fff"
              strokeWidth={6}
            />
          </g>
          <defs>
            <filter
              id="filter4_concave"
              x={0}
              y={0}
              width={104}
              height={142.416}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M98.893 129.184c-16.58 16.309-77.206 16.309-93.786 0-10.419-10.248 2.271-34.11 2.271-57.979 0-23.867-12.69-47.726-2.27-57.974 16.579-16.308 77.205-16.308 93.785 0 10.419 10.248-2.271 34.111-2.271 57.98 0 23.867 12.69 47.721 2.27 57.973z"
            fill="#fff"
            stroke="#A2A2A2"
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M52.002 132.143c-18.327 0-35.245-4.077-41.138-9.917-2.653-2.627-.55-12.994 1.306-22.141 1.771-8.734 3.78-18.632 3.78-28.877 0-10.245-2.009-20.143-3.78-28.877-1.855-9.148-3.96-19.515-1.306-22.142 5.893-5.84 22.81-9.916 41.138-9.916s35.246 4.076 41.135 9.916c2.653 2.632.549 12.994-1.306 22.142-1.772 8.734-3.78 18.632-3.78 28.877 0 10.245 2.008 20.143 3.78 28.877 1.855 9.147 3.959 19.514 1.306 22.141-5.89 5.84-22.807 9.917-41.135 9.917z"
            fill="#fff"
            stroke="#A2A2A2"
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M52.041 93.147c12.094 0 21.899-9.804 21.899-21.898S64.135 49.351 52.04 49.351c-12.094 0-21.898 9.804-21.898 21.898s9.804 21.898 21.898 21.898z"
            stroke="#A2A2A2"
            strokeWidth={6}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M52.041 59.427v8.567c0 2.084.826 4.087 2.303 5.564l5.017 5.016"
            stroke="#A2A2A2"
            strokeWidth={6}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconConcaveCylinderTime
